import { createAsyncThunk } from '@reduxjs/toolkit';
import { MyThunkApiConfig } from '../../types';

export const fetchAllConfirmJobList = createAsyncThunk<
  any,
  { graphqlFunction: (params: any) => Promise<any>; params: any },
  MyThunkApiConfig
>('confirmJob/fetchAllConfirmJob', async (inputData, { rejectWithValue }) => {
  const { graphqlFunction, params } = inputData;
  try {
    const response = await graphqlFunction(params);
    return response;
  } catch (error) {
    return rejectWithValue({ error: error.message });
  }
});
